import { render } from "./ClassicView.vue?vue&type=template&id=8408f4a0&scoped=true"
import script from "./ClassicView.vue?vue&type=script&lang=js"
export * from "./ClassicView.vue?vue&type=script&lang=js"

import "./ClassicView.vue?vue&type=style&index=0&id=8408f4a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8408f4a0"]])

export default __exports__